export default {
	firebaseConfig: {
		apiKey: "AIzaSyAIIj1p3e6LmMSw2YT8Cm_6gO4qUu_DPvE",
    authDomain: "mg-dealer.firebaseapp.com",
    databaseURL: "https://mg-dealer.firebaseio.com",
    storageBucket: "mg-dealer.appspot.com",
    messagingSenderId: "339694380249"
	}
};



// WEBPACK FOOTER //
// ./src/firebase/config.js